// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import authServices from '../services/AuthServices';
import { loginSession } from '../api/apiService';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({ isAuthenticated: false, user: null });
  const navigate = useNavigate();

  useEffect(() => {


    const checkToken = async () => {
      const token = authServices.getToken();
      if (token) {
        try {
          const response = await loginSession()
          if (response.response === "SUCCESS") {
            setAuthState({ isAuthenticated: true, user: { name: 'authToken' } });
            navigate('/');
          } else {
            authServices.logout()
          }
        } catch (error) {

        }
      }

    }

    checkToken();

  }, []);


  const login = async (Token) => {
    // const token = await authServices.login(Token);
    setAuthState({ isAuthenticated: true, user: { name: 'authToken' } });
    navigate('/');
  };


  const logout = () => {
    authServices.logout();
    setAuthState({ isAuthenticated: false, user: null });
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ authState, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);


export default AuthContext;
